/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VerifyAccountRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {VerifyAccountResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const verifyAccount = (request: VerifyAccountRequest, options?: CashRequestOptions) => post<VerifyAccountRequest, VerifyAccountResponse>("/cash-app/local/verify-account", request, {...options, rejectOnError: true })